import { detectionCategory } from 'json/lab-order'
export let filterFactor = [ {
  label: '类型',
  type: 'select',
  clearable: true,
  value: 'category', // 需返回数据的字段名
  options: getTypes()
}]
function getTypes () {
  let options = []
  detectionCategory.forEach(item => {
    let signalItem = {
      label: item.value,
      value: item.key
    }
    options.push(signalItem)
  })
  return options
}
